import { useState } from 'react';

const TYPE_LEGEND = [
  { color: '#3b82f6', label: 'UI' },
  { color: '#6b7280', label: 'API' },
  { color: '#22c55e', label: 'Data' },
  { color: '#8b5cf6', label: 'Util' },
  { color: '#f97316', label: 'Config' },
  { color: '#eab308', label: 'Test' },
  { color: '#ec4899', label: 'Entry' },
  { color: '#64748b', label: 'Core' },
];

const COMPLEXITY_LEGEND = [
  { color: '#22c55e', label: '< 5 Low' },
  { color: '#eab308', label: '< 10 Medium' },
  { color: '#f97316', label: '< 20 High' },
  { color: '#ef4444', label: '20+ Critical' },
];

const CHURN_LEGEND = [
  { color: '#22c55e', label: '< 3 Low' },
  { color: '#eab308', label: '< 8 Medium' },
  { color: '#f97316', label: '< 15 High' },
  { color: '#ef4444', label: '15+ Critical' },
];

const LOC_LEGEND = [
  { color: '#22c55e', label: '< 500 Low' },
  { color: '#eab308', label: '< 1500 Medium' },
  { color: '#f97316', label: '< 5000 High' },
  { color: '#ef4444', label: '5000+ Critical' },
];

const LEGENDS = {
  type: { title: 'Boundary / Role', items: TYPE_LEGEND },
  complexity: { title: 'Avg Complexity', items: COMPLEXITY_LEGEND },
  churn: { title: 'Change Frequency', items: CHURN_LEGEND },
  loc: { title: 'Lines of Code', items: LOC_LEGEND },
};

export default function ColorLegend({ colorMode }) {
  const [collapsed, setCollapsed] = useState(false);
  const legend = LEGENDS[colorMode] || LEGENDS.type;

  return (
    <div className={`color-legend ${collapsed ? 'collapsed' : ''}`}>
      <button
        className="color-legend-toggle"
        onClick={() => setCollapsed(!collapsed)}
        title={collapsed ? 'Show legend' : 'Hide legend'}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <line x1="3" y1="9" x2="21" y2="9"/>
          <line x1="9" y1="9" x2="9" y2="21"/>
        </svg>
        <span>{legend.title}</span>
        <svg
          className="color-legend-chevron"
          width="10" height="10"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points={collapsed ? '6 9 12 15 18 9' : '18 15 12 9 6 15'} />
        </svg>
      </button>
      {!collapsed && (
        <div className="color-legend-items">
          {legend.items.map((item) => (
            <div key={item.label} className="color-legend-item">
              <span className="color-legend-swatch" style={{ backgroundColor: item.color }} />
              <span className="color-legend-label">{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
